// 专辑管理路由
const album = {
    path: 'album',
    component: () => import('@/components/RouterView'),
    meta: { title: '专辑管理' },
    redirect: '/manage/album/list',
    children: [
        {
            path: 'list',
            component: () => import('@/views/manage/albumManage/album/albumList'),
            meta: { title: '专辑管理列表' },
        },
        {
            path: 'detail/:albumId',
            component: () => import('@/views/manage/albumManage/album/detail'),
            meta: { title: '专辑详情' },
        },
        {
            path: 'share/:albumId',
            component: () => import('@/views/manage/albumManage/album/share'),
            meta: { title: '专辑管理列表' },
        },
        {
            path: 'add',
            component: () => import('@/views/manage/albumManage/album/albumInfo/baseInfo'),
            meta: { title: '新增专辑' },
        },
        {
            path: 'info/:albumId',
            component: () => import('@/views/manage/albumManage/album/albumInfo/baseInfo'),
            meta: { title: 'EP/专辑' },
            props: true,
        },
        {
            path: 'songList/:albumId',
            component: () => import('@/views/manage/albumManage/album/albumInfo/trackList'),
            meta: { title: '歌曲列表' },
            props: true,
        },
        {
            path: 'info/:albumId/success',
            component: () => import('@/views/manage/albumManage/album/albumInfo/success'),
            meta: { title: '提交成功' },
            props: true,
        },
        {
            path: 'trackInfo/:albumId',
            component: () => import('@/views/manage/albumManage/album/albumInfo/trackInfo'),
            meta: { title: '新增歌曲' },
            props: true,
        },
        {
            path: 'trackInfo/:albumId/:trackId',
            component: () => import('@/views/manage/albumManage/album/albumInfo/trackInfo'),
            meta: { title: '编辑歌曲' },
            props: true,
        },
        {
            path: 'singleTrackInfo/add',
            component: () => import('@/views/manage/albumManage/album/singleTrackInfo'),
            meta: { title: '新增单曲专辑' },
        },
        {
            path: 'singleTrackInfo/info/:albumId',
            component: () => import('@/views/manage/albumManage/album/singleTrackInfo'),
            meta: { title: '专辑信息' },
            props: true,
        },
    ],
};

export default album;
